module.exports = __webpack_public_path__ + "static/website-banner-677d1c1e4564353cfbcc6d40dd299e2d.png";